import {Component, Input, Output, EventEmitter} from '@angular/core';
import { CompareService } from '../../../services/compare/compare.service';
import { ContentService } from '../../../services/content/content.service';

const content = require('./compare-dialog.content.json');

@Component({
  selector: 'app-compare-dialog',
  templateUrl: './compare-dialog.component.html',
  styleUrls: ['./compare-dialog.component.scss']
})
export class CompareDialogComponent {
  @Input()
  public visible: boolean = true;

  @Input()
  public minimized: boolean = false;

  @Output()
  public minimizedEvent = new EventEmitter<boolean>();

  public itemsToCompare: any[] = [];

  public constructor(private compareService: CompareService, private contentService: ContentService) {
    contentService.loadContent(content);
    this.compareService.getItemsToCompare$().subscribe((itemsToCompare: any[]) => {
      this.itemsToCompare = itemsToCompare;
    });
  }

  public removeItem($event): void {
    this.compareService.requestRemove($event);
  }

  public toggleDialog():void{
    this.minimized = !this.minimized;
    this.minimizedEvent.next(this.minimized);
  }
}
